import "./VehiclesCreate.scss";

import { useVehiclesCreateForm } from "../../../hooks/useVehiclesCreateForm";
import { useGetVehiclesFieldOptions } from "../../../hooks/useGetVehiclesFieldOptions";

import { Field } from "../../../common-components/Field/Field";

const VehiclesCreate = () => {
    const { formId, adaptedFieldList } = useVehiclesCreateForm();

    useGetVehiclesFieldOptions();

    return (
        <div className={"vehicles-report-create"}>
            <div className={"vehicles-report-create_container"}>
                <div className={"vehicles-report-create_form"}>
                    {adaptedFieldList.map((category) => (
                        <div className={"vehicles-report-create_form-category"}>
                            <div className={"vehicles-report-create_form-category_title"}>
                                {category.category}
                                <div className={"vehicles-report-create_form-category_attention"}>
                                    {category.categoryAttention}
                                </div>
                            </div>
                            <div className={"vehicles-report-create_form-category_items"}>
                                {category.fields.map((field) => (
                                    <Field
                                        key={field.name}
                                        label={field.label}
                                        name={field.name}
                                        options={field.options}
                                        formId={formId}
                                        propertyLabel={field.label}
                                        type={field.type}
                                        validationRules={field.validationRules}
                                        fieldStructure={field.fieldStructure}
                                    />
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default VehiclesCreate;